import Application from "../../Application";
import OrganisationPresenter, {
  IOrganisationPresenter
} from "../presenter/OrganisationPresenter";
import GetAllOrganisationsInteractor from "./GetAllOrganisationsInteractor";
import GetAllCaseLawDocumentTypesInteractor from "../../caseLawDocuments/interactor/GetAllCaseLawDocumentTypesInteractor";
import GetAllRegistryInstitutionsInteractor from "./GetAllRegistryInstitutionsInteractor";

export default class ShowOrganisationsInteractor {
  private application: Application;
  private output?: IOrganisationPresenter;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;
  private getAllRegistryInstitutionsInteractor: GetAllRegistryInstitutionsInteractor;
  private getAllCaseLawDocumentTypesInteractor: GetAllCaseLawDocumentTypesInteractor;

  constructor({
    application,
    getAllOrganisations,
    getAllRegistryInstitutions,
    getAllCaseLawDocumentTypes
  }: any) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getAllRegistryInstitutionsInteractor = getAllRegistryInstitutions;
    this.getAllCaseLawDocumentTypesInteractor = getAllCaseLawDocumentTypes;
  }

  private async getAllInstitutions() {
    return this.getAllRegistryInstitutionsInteractor.execute();
  }

  private async getReferenceLists() {
    return Promise.all([this.getAllInstitutions()]);
  }

  execute() {
    this.output = OrganisationPresenter({
      application: this.application,
      initialState: {
        organisations: [],
        institutions: []
      }
    });
    this.getReferenceLists()
      .then(([institutions]) => this.output?.loadReferenceValues(institutions))
      .then(() => this.getAllOrganisationsInteractor.execute())
      .then(this.output.loadAllOrganisations);

    return this.output;
  }
}
